import { useContext, useEffect, useState } from "react";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { isValidArray } from "../../Layout/Common/common";
import { ProductCard } from "../../Layout/Common/productCard";
import { ProductCarouselSection } from "../../Layout/Common/productCarouselSection";
import { GlobalContext } from "../../Context/GlobalContext";
import { axiosInstance } from "../../axios/axiosInstance";
import { useAuth } from "../../Context/AuthContext";
import { useParams } from "react-router-dom";

export const PopularProductContainer = ({ params }) => {
  const [productList, setProductList] = useState(null);
  const { userId, companyId, priceCode } = useAuth();
  const { fid } = useParams();

  useEffect(() => {
    if (params && params.familyId) {
      var payload = {
        familyId: params.familyId,
        userId: String(userId),
        categoryId: fid,
        priceCode: String(priceCode ?? 3),
        key: "0",
      };
      axiosInstance
        .post("ProductNew/GetPopularProduct", payload)
        .then((response) => {
          if (isValidArray(response.data)) {
            setProductList(response.data);
            if (isValidArray(response.data) && response.data.length < 8) {
              loadRootLevelPopularProduct(payload);
            }
          } else {
            loadRootLevelPopularProduct(payload);
          }
        })
        .catch((error) => console.log(error.message));
    }
  }, [params]);

  const loadRootLevelPopularProduct = (payload) => {
    var request = {
      ...payload,
      key: "1",
    };
    axiosInstance.post("ProductNew/GetPopularProduct", request).then((response) => {
      if (response.data && isValidArray(response.data)) {
        if (isValidArray(productList)) setProductList([...productList, ...response.data]);
        else setProductList(response.data);
      }
    });
  };

  function checkAutoPlay(list) {
    if (isValidArray(productList) && Array(productList).length > 4) return true;
    else return false;
  }

  return (
    <ProductCarouselSection
      title="Popluar Products"
      sectionClassName="filter-popular-section"
      sectionId="section-popluarProducts"
      items={productList}
      getItemKey={(row, index) => row?.productId ?? index}
      renderItem={(row) => <ProductCard data={row} />}
    />
  );
};
